import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { trackGtm } from '../../utils';

export default class Image extends React.Component {
  trackClick(dataObj) {
    if (typeof window !== 'undefined') trackGtm({ ...dataObj, page: window.location.pathname });
  }

  render() {
    const { link, download, overlay } = this.props;
    return link ? (
      <a
        href={link}
        onClick={() => this.trackClick({ event: 'imageLink', imageUrl: link })}
        download={download === 'true'}
        className="section image-block__link"
      >
        {overlay ? <div className="image-block__link-overlay">{overlay}</div> : null}
        {this.renderCaptionedImage()}
      </a>
    ) : (
      this.renderCaptionedImage()
    );
  }

  renderCaptionedImage() {
    const { caption } = this.props;
    return caption ? (
      <figure className="section image-block__figure">
        {this.renderImage()}
        <figcaption>{caption}</figcaption>
      </figure>
    ) : (
      this.renderImage()
    );
  }

  renderImage() {
    const {
      src,
      alt,
      maxWidth,
      className,
      containerClassName,
      hideOnMobile,
      hideOnDesktop,
      customMargin,
      alignment,
      colourScheme,
      overflowMobile,
      id,
      disableLazyLoad
    } = this.props;

    const componentClasses = classNames('image-block-container', {
      [containerClassName]: containerClassName,
      [`image-block-container--${colourScheme}`]: colourScheme,
      'image-block-container--overflow-mobile': overflowMobile,
      [`image-block-container--align-${alignment}`]: alignment
    });

    const imageClasses = classNames('image-block', {
      [className]: className,
      'image-block--hide-on-mobile': hideOnMobile,
      'image-block--hide-on-desktop': hideOnDesktop,
      [`image-block--${customMargin}-margin`]: customMargin
    });

    const Component = disableLazyLoad ? 'img' : LazyLoadImage;

    return (
      <div id={id} className={componentClasses}>
        <Component
          src={src}
          alt={alt}
          className={imageClasses}
          style={maxWidth ? { maxWidth: `${maxWidth}px`, width: '100%' } : null}
        />
      </div>
    );
  }
}

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  id: PropTypes.string,
  link: PropTypes.string,
  download: PropTypes.string,
  overlay: PropTypes.string,
  maxWidth: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  hideOnMobile: PropTypes.string,
  hideOnDesktop: PropTypes.string,
  alignment: PropTypes.oneOf(['right', 'left', 'bottom']),
  customMargin: PropTypes.oneOf(['no-bottom', 'no-top', 'no-top-bottom']),
  colourScheme: PropTypes.oneOf(['light-grey', 'sand', 'neutral-navy', 'dark-navy']),
  disableLazyLoad: PropTypes.string
};
